import createIcon from '../../createIcon';

/**
 * @component @name GridGoldenratio
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTFWOUgxNVYySDEzVjlIMTFWMkg5VjlIMlYxMUg5VjEzSDJWMTVIOVYyMkgxMVYxNUgxM1YyMkgxNVYxNUgyMlYxM0gxNVYxMUgyMlpNMTMgMTNIMTFWMTFIMTNWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GridGoldenratio = createIcon('GridGoldenratio', [
  [
    'path',
    {
      d: 'M22 11V9H15V2H13V9H11V2H9V9H2V11H9V13H2V15H9V22H11V15H13V22H15V15H22V13H15V11H22ZM13 13H11V11H13V13Z',
      key: '11p5g9',
    },
  ],
]);

export default GridGoldenratio;
